/* ═══════════════════════════════════════════════
   Aishita Johri PRE-LAUNCH THEME — VANILLA JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
  var isMobileStatic = window.matchMedia('(max-width: 768px)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (isMobileStatic) {
    document.body.classList.add('is-mobile-static');
  }

  if (!isMobileStatic && !reduceMotion) {
    initScrollAnimations();
    initEditorialMotion();
  }
  initNavigation();
  initViewportImages();
  initImageReadiness();
  initCommerceBreadcrumbContext();
  initCommerceSheets();
  initHomeHeroVideo();
  initHomeLuxuryHeroCarousel();
  initLazyVideos();
  initEditorialVideos();
  initHomeLuxuryFilmAudio();
  initWeavingLoom();
  initMakingGallery();
  initCountdown();
  if (!isMobileStatic && !reduceMotion) {
    initSequentialWords();
    initStaggeredColorWords();
    initScrollRevealText();
    initParallax();
  }
  initFooterBannerPicker();
  initPhoneInputs();
  initWaitlistForm();
  initContactForm();
  initWyshPage();
  initReducedMotionMedia();
  restorePostedFormState({
    formId: 'home-cta-form',
    stateSelector: '[data-home-cta-form-state]',
    successTargetId: 'home-cta-done',
    errorTargetId: 'home-cta-form-wrap'
  });
  restorePostedFormState({
    formId: 'waitlist-form',
    stateSelector: '[data-waitlist-form-state]',
    successTargetId: 'waitlist-done',
    errorTargetId: 'waitlist-form-wrap'
  });
});

document.addEventListener('shopify:section:load', function (event) {
  initViewportImages(event.target);
  initImageReadiness(event.target);
  initEditorialVideos(event.target);
  if (!event.target.querySelector('[data-home-hero-carousel]')) return;
  initHomeLuxuryHeroCarousel(event.target);
  initLazyVideos();
  initHomeLuxuryFilmAudio();
});

var __phoneInputRegistry = [];

// Retain surfaces during their exit transition. Reopening cancels the pending
// hide, so CSS reverses from the current position rather than starting over.
var __surfaceCloseTimers = new WeakMap();
function setAnimatedSurfaceState(surface, open, afterClose) {
  if (!surface) return;
  window.clearTimeout(__surfaceCloseTimers.get(surface));
  __surfaceCloseTimers.delete(surface);
  surface.setAttribute('aria-hidden', open ? 'false' : 'true');
  surface.inert = !open;
  if (open) {
    var wasHidden = surface.hidden || surface.style.display === 'none';
    surface.hidden = false;
    surface.style.display = '';
    if (wasHidden) surface.getBoundingClientRect();
    surface.classList.add('is-visible');
    return;
  }
  surface.classList.remove('is-visible');
  function finishClose() {
    surface.hidden = true;
    surface.style.display = 'none';
    __surfaceCloseTimers.delete(surface);
    if (afterClose) afterClose();
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finishClose();
  } else {
    __surfaceCloseTimers.set(surface, window.setTimeout(finishClose, 260));
  }
}

// Only pending, below-the-fold imagery gets a one-time reveal. Cached and hero
// images render immediately; failed downloads remain visible to expose alt text.
function initViewportImages(root) {
  var images = Array.from((root || document).querySelectorAll('img[data-defer-to-viewport][data-src]')).filter(function (image) {
    return !image.dataset.viewportBound;
  });
  if (!images.length) return;
  function load(image) {
    if (!image.dataset.src) return;
    image.loading = 'eager';
    var picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source[data-srcset]').forEach(function (source) {
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
      });
    }
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      delete image.dataset.srcset;
    }
    image.src = image.dataset.src;
    delete image.dataset.src;
  }
  if (!('IntersectionObserver' in window)) {
    images.forEach(load);
    return;
  }
  function observe(targets, margin) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: margin });
    targets.forEach(function (image) {
      image.dataset.viewportBound = 'true';
      if (image.dataset.src) observer.observe(image);
    });
  }
  var productGalleryImages = images.filter(function (image) {
    return image.hasAttribute('data-wait-for-primary');
  });
  var regularImages = images.filter(function (image) {
    return !image.hasAttribute('data-wait-for-primary');
  });
  // Visible images always load, including when someone scrolls immediately.
  // Nearby, still-offscreen images must not compete with the first hero.
  var hero = document.querySelector('[data-home-hero-slide].is-active img');
  var heroPending = hero && !hero.complete;
  observe(regularImages, heroPending ? '0px' : '600px 0px');
  if (heroPending) {
    function warmNearbyImages() {
      hero.removeEventListener('load', warmNearbyImages);
      hero.removeEventListener('error', warmNearbyImages);
      observe(regularImages, '600px 0px');
    }
    hero.addEventListener('load', warmNearbyImages);
    hero.addEventListener('error', warmNearbyImages);
  }
  if (productGalleryImages.length) {
    productGalleryImages.forEach(function (image) { image.dataset.viewportBound = 'waiting'; });
    var primaryProductImage = document.querySelector('.product-editorial__image[loading="eager"]');
    var releaseProductGallery = function () {
      var start = function () { observe(productGalleryImages, '600px 0px'); };
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1200 });
      else window.setTimeout(start, 0);
    };
    if (!primaryProductImage || primaryProductImage.complete) releaseProductGallery();
    else {
      primaryProductImage.addEventListener('load', releaseProductGallery, { once: true });
      primaryProductImage.addEventListener('error', releaseProductGallery, { once: true });
    }
    var productRail = document.querySelector('[data-media-rail]');
    if (productRail) {
      var warmNextProductImage = function () {
        var nextImage = productGalleryImages.find(function (image) { return image.dataset.src; });
        if (nextImage) load(nextImage);
      };
      productRail.addEventListener('pointerdown', warmNextProductImage, { once: true, passive: true });
      productRail.addEventListener('focusin', warmNextProductImage, { once: true });
    }
  }
}

function initImageReadiness(root) {
  (root || document).querySelectorAll('img[loading="lazy"]').forEach(function (image) {
    if (image.dataset.readinessBound || image.complete || image.closest('.nav-brand, .product-editorial__media-rail')) return;
    image.dataset.readinessBound = '1';
    if (image.getBoundingClientRect().top < window.innerHeight) return;
    image.classList.add('is-image-pending');
    function reveal() { image.classList.remove('is-image-pending'); }
    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', reveal, { once: true });
  });
}

function initReducedMotionMedia() {
  var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function sync() {
    document.querySelectorAll('video').forEach(function (video) {
      if (preference.matches) {
        if (video.autoplay) video.dataset.motionAutoplay = 'true';
        video.autoplay = false;
        video.pause();
      } else if (video.dataset.motionAutoplay === 'true') {
        video.autoplay = true;
      }
    });
  }
  preference.addEventListener('change', sync);
  sync();
}

function setPhoneFallbackState(entry, enabled) {
  if (!entry) return;

  var fallback = entry.querySelector('[data-phone-fallback]');
  var phoneInput = entry.querySelector('.js-phone-input');
  if (!fallback || !phoneInput) return;

  fallback.hidden = !enabled;
  entry.classList.toggle('is-phone-fallback', enabled);
  phoneInput.placeholder = enabled ? 'Phone number' : 'Phone';
}

function initPhoneInputs() {
  var phoneInputs = document.querySelectorAll('.js-phone-input');
  if (!phoneInputs.length) return;

  if (!window.intlTelInput) {
    phoneInputs.forEach(function (input) {
      var entry = input.closest('[data-phone-entry]');
      var codeInput = entry ? entry.querySelector('[data-phone-country-code]') : null;

      setPhoneFallbackState(entry, true);
      if (codeInput) {
        codeInput.addEventListener('input', function () {
          codeInput.value = String(codeInput.value || '').replace(/\D/g, '').slice(0, 3);
        });
      }
    });
    return;
  }

  phoneInputs.forEach(function (input) {
    if (input.dataset.phoneInputInit) return;

    var entry = input.closest('[data-phone-entry]');

    var iti = intlTelInput(input, {
      initialCountry: 'in',
      separateDialCode: true,
      nationalMode: false,
      autoPlaceholder: 'aggressive',
      formatOnDisplay: true,
      dropdownContainer: document.body,
      utilsScript: window.themeRoutes && window.themeRoutes.intlTelUtils ? window.themeRoutes.intlTelUtils : ''
    });

    setPhoneFallbackState(entry, false);
    input.dataset.phoneInputInit = '1';
    input.dataset.phoneInputIndex = String(__phoneInputRegistry.length);
    __phoneInputRegistry.push({ input: input, iti: iti });
  });
}

function getPhoneNumberValue(input) {
  if (!input) return '';

  var index = input.dataset && input.dataset.phoneInputIndex;
  if (index !== undefined && __phoneInputRegistry[index] && __phoneInputRegistry[index].iti) {
    var value = __phoneInputRegistry[index].iti.getNumber();
    if (value) return value;
  }

  var entry = input.closest('[data-phone-entry]');
  var codeInput = entry ? entry.querySelector('[data-phone-country-code]') : null;
  var rawValue = String(input.value || '').trim();
  var normalizedValue = rawValue.replace(/\s+/g, '');

  if (!normalizedValue) return '';
  if (normalizedValue.charAt(0) === '+') return normalizedValue;

  if (codeInput && !codeInput.closest('[hidden]')) {
    var countryCode = String(codeInput.value || '').replace(/\D/g, '').slice(0, 3);
    var localNumber = normalizedValue.replace(/\D/g, '');

    if (!localNumber) return countryCode ? '+' + countryCode : '';
    if (countryCode) return '+' + countryCode + localNumber;
    return localNumber;
  }

  return normalizedValue;
}

function cleanContactPostedUrl() {
  if (!window.history || !window.history.replaceState) return;
  if (window.location.search.indexOf('contact_posted=true') === -1) return;

  window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
}

function scrollToPostedFormState(target) {
  if (!target) return;

  window.requestAnimationFrame(function () {
    window.setTimeout(function () {
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    }, 140);
  });
}

function restorePostedFormState(config) {
  if (!config || !config.formId || !config.stateSelector) return;

  var form = document.getElementById(config.formId);
  if (!form) return;

  var stateEl = form.querySelector(config.stateSelector);
  if (!stateEl) return;

  var postedSuccessfully = stateEl.getAttribute('data-posted-successfully') === 'true';
  var hasErrors = stateEl.getAttribute('data-has-errors') === 'true';

  if (!postedSuccessfully && !hasErrors) return;

  cleanContactPostedUrl();
  scrollToPostedFormState(document.getElementById(postedSuccessfully ? config.successTargetId : config.errorTargetId));
}

function initCommerceBreadcrumbContext() {
  var storageKey = 'aj-commerce-breadcrumb-context';
  var contextLinks = document.querySelectorAll('[data-breadcrumb-context-link]');
  var breadcrumbLink = document.querySelector('[data-product-breadcrumb-link]');

  contextLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var label = link.getAttribute('data-breadcrumb-label');
      var url = link.getAttribute('data-breadcrumb-url');

      if (!label || !url) return;

      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          label: label,
          url: url,
          timestamp: Date.now()
        }));
      } catch (error) {
      }
    });
  });

  if (!breadcrumbLink) return;

  var fallbackLabel = breadcrumbLink.getAttribute('data-default-label') || 'Shop';
  var fallbackUrl = breadcrumbLink.getAttribute('data-default-url') || '/collections/all';
  var appliedContext = null;

  try {
    appliedContext = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
  } catch (error) {
    appliedContext = null;
  }

  var isUsableContext = appliedContext &&
    typeof appliedContext.label === 'string' &&
    typeof appliedContext.url === 'string' &&
    appliedContext.url.indexOf('/collections/') === 0;

  var targetLabel = isUsableContext ? appliedContext.label : fallbackLabel;
  var targetUrl = isUsableContext ? appliedContext.url : fallbackUrl;

  breadcrumbLink.textContent = targetLabel;
  breadcrumbLink.setAttribute('href', targetUrl);
}

/* ═══════════════════════════════════════════════
   1. SCROLL REVEAL ANIMATIONS
   ═══════════════════════════════════════════════ */

function initScrollAnimations() {
  var elements = document.querySelectorAll('.reveal, .clip-reveal, .scale-in');
  if (!elements.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });

  elements.forEach(function (el) { observer.observe(el); });
}

function initEditorialMotion() {
  var sectionSelectors = [
    '.video-hero',
    '.subhero',
    '.founder-hero',
    '.home-luxury__hero',
    '.home-luxury__brand',
    '.home-luxury__film',
    '.home-luxury__collections',
    '.home-luxury__products',
    '.brand-section',
    '.philosophy-section',
    '.home-cta',
    '.hero-cinematic',
    '.film-letter',
    '.film-craft',
    '.film-artisans',
    '.film-founder',
    '.film-metamorphosis',
    '.kaarigar-section',
    '.contact-section',
    '.making-hero-v2',
    '.making-atlas',
    '.making-closing',
    '.making-atelier',
    '.collection-story__header',
    '.collection-story__video-row',
    '.collection-story__sequence',
    '.collection-shell__grid',
    '.collection-shell__pagination',
    '.collection-shell__empty',
    '.site-footer'
  ];

  var itemSelectors = [
    'h1', 'h2', 'h3', 'p', 'blockquote',
    '.home-luxury__hero-media',
    '.home-luxury__hero-copy',
    '.home-luxury__hero-links',
    '.home-luxury__collection-card',
    '.home-luxury__product-card',
    '.brand-section__media',
    '.founder-hero__image-block',
    '.founder-hero__portrait-wrap',
    '.founder-hero__label',
    '.founder-hero__wordmark',
    '.founder-hero__hindi-name',
    '.founder-hero__bio',
    '.philosophy-section__pillar',
    '.home-cta__tier-wrap',
    '.home-cta__form-wrap',
    '.home-cta__done',
    '.kaarigar-card',
    '.collection-story__heading',
    '.collection-story__intro',
    '.collection-story__video-frame',
    '.story-card',
    '.collection-card',
    '.making-textile',
    '.making-atelier-card',
    '.making-place-card',
    '.making-chapter',
    '.footer-brand',
    '.footer-col',
    'img',
    'video',
    'button',
    'a'
  ];

  var sections = document.querySelectorAll(sectionSelectors.join(','));
  if (!sections.length) return;

  function prepareSection(section) {
    if (!section) return;

    if (!section.hasAttribute('data-editorial-group')) {
      section.setAttribute('data-editorial-group', '');
    }

    var items = section.querySelectorAll(itemSelectors.join(','));
    var seen = [];

    items.forEach(function (item) {
      if (!item || item.closest('[data-editorial-item]')) return;
      if (item.closest('.mobile-menu')) return;
      if (item.closest('.footer-legal')) return;
      if (item.closest('.footer-ornament')) return;
      if (item.closest('.making-gallery__viewport')) return;
      if (item.closest('.home-cta__tier-wrap') && !item.classList.contains('home-cta__tier-wrap')) return;
      if (item.closest('.philosophy-section__pillar') && !item.classList.contains('philosophy-section__pillar')) return;
      if (seen.indexOf(item) !== -1) return;

      seen.push(item);
      item.setAttribute('data-editorial-item', '');
    });
  }

  function applyDelays(section) {
    if (!section) return;

    var items = section.querySelectorAll('[data-editorial-item]');
    items.forEach(function (item, index) {
      item.style.setProperty('--editorial-delay', Math.min(index * 85, 700) + 'ms');
    });
  }

  function revealSection(section) {
    if (!section) return;
    applyDelays(section);
    section.classList.add('is-editorial-visible');
  }

  sections.forEach(prepareSection);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach(function (section) {
      revealSection(section);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealSection(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  sections.forEach(function (section) {
    observer.observe(section);
  });

  window.__ajEditorialMotion = {
    prepareSection: prepareSection,
    revealSection: revealSection
  };
}

function initMakingGallery() {
  var sections = document.querySelectorAll('.making-atlas');
  if (!sections.length) return;

  sections.forEach(function (atlas) {
    var viewport = atlas.querySelector('[data-making-gallery-viewport]');
    var cards = Array.prototype.slice.call(atlas.querySelectorAll('[data-making-gallery-card]'));
    if (!viewport || !cards.length) return;

    var mq = window.matchMedia('(min-width: 769px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var viewportWidth = 0;
    var cardWidth = 280;
    var gap = 34;
    var totalWidth = 0;
    var curveDepth = 115;
    var rafId = null;
    var spacing = 0;
    var scroll = { current: 0 };
    var isHoverPaused = false;
    var isDragging = false;
    var lastTime = 0;
    var autoSpeed = 44;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var suppressClicksUntil = 0;

    initMediaSwitchers(atlas);

    function normalizeScroll(value) {
      if (!totalWidth) return 0;
      return ((value % totalWidth) + totalWidth) % totalWidth;
    }

    function refresh() {
      viewportWidth = viewport.clientWidth;
      cardWidth = cards[0].offsetWidth || 280;
      gap = Math.max(24, Math.min(42, viewportWidth * 0.03));
      spacing = cardWidth + gap;
      totalWidth = Math.max(cards.length * spacing, 1);
    }

    function positionCards() {
      if (!mq.matches) {
        cards.forEach(function(card) {
          card.style.transform = '';
          card.style.opacity = '';
          card.style.zIndex = '';
        });
        return;
      }

      var centerShift = (viewportWidth - cardWidth) / 2;
      cards.forEach(function(card, index) {
        var wrappedX = centerShift + index * spacing - scroll.current;
        while (wrappedX < -cardWidth - gap) {
          wrappedX += totalWidth;
        }
        while (wrappedX > viewportWidth + gap) {
          wrappedX -= totalWidth;
        }
        var x = wrappedX;
        var cardCenter = wrappedX + cardWidth / 2;
        var relative = (cardCenter - viewportWidth / 2) / (viewportWidth / 2);
        var limited = Math.max(-1.35, Math.min(1.35, relative));
        var depth = Math.min(Math.abs(limited), 1.15);
        var y = depth * depth * curveDepth;
        var rotation = limited * 9;
        var scale = 1 - Math.min(depth * 0.07, 0.07);
        var opacity = 1 - Math.min(Math.abs(limited) * 0.2, 0.2);
        var zIndex = 1000 - Math.round(Math.abs(relative) * 100);

        card.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) rotate(' + rotation + 'deg) scale(' + scale + ')';
        card.style.opacity = opacity.toFixed(3);
        card.style.zIndex = String(zIndex);
      });
    }

    function tick(time) {
      if (!mq.matches || reducedMotion.matches || document.hidden) {
        rafId = null;
        return;
      }
      rafId = window.requestAnimationFrame(tick);
      if (!lastTime) {
        lastTime = time;
      }
      var deltaSeconds = Math.min((time - lastTime) / 1000, 0.05);
      lastTime = time;
      if (!isHoverPaused && !isDragging) {
        scroll.current = normalizeScroll(scroll.current + autoSpeed * deltaSeconds);
      }
      positionCards();
    }

    function onPointerEnter() {
      if (!mq.matches) return;
      isHoverPaused = true;
    }

    function onPointerLeave() {
      if (!mq.matches) return;
      isHoverPaused = false;
    }

    function onPointerDown(event) {
      if (!mq.matches) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = scroll.current;
      lastTime = 0;
      viewport.setPointerCapture(event.pointerId);
    }

    function onPointerMove(event) {
      if (!mq.matches || !isDragging) return;
      var deltaX = event.clientX - dragStartX;
      if (Math.abs(deltaX) > 6) {
        dragMoved = true;
      }
      scroll.current = normalizeScroll(dragStartScroll - deltaX);
      positionCards();
    }

    function onPointerUp(event) {
      if (!isDragging) return;
      if (dragMoved) {
        suppressClicksUntil = window.performance.now() + 250;
      }
      isDragging = false;
      dragMoved = false;
      lastTime = 0;
      if (event && typeof viewport.releasePointerCapture === 'function') {
        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function onClickCapture(event) {
      if (window.performance.now() < suppressClicksUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function onResize() {
      lastTime = 0;
      refresh();
      scroll.current = normalizeScroll(scroll.current);
      positionCards();
      startTick();
    }

    function startTick() {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = null;
      lastTime = 0;
      if (mq.matches && !reducedMotion.matches && !document.hidden) rafId = window.requestAnimationFrame(tick);
    }

    viewport.addEventListener('mouseenter', onPointerEnter);
    viewport.addEventListener('mouseleave', onPointerLeave);
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('pointerleave', onPointerUp);
    viewport.addEventListener('click', onClickCapture, true);
    window.addEventListener('resize', onResize);
    reducedMotion.addEventListener('change', startTick);
    document.addEventListener('visibilitychange', startTick);

    if (mq.addEventListener) {
      mq.addEventListener('change', onResize);
    } else if (mq.addListener) {
      mq.addListener(onResize);
    }

    refresh();
    positionCards();
    startTick();
  });
}

function initMediaSwitchers(scope) {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var switchers = scope.querySelectorAll('[data-making-media-switcher]');
  if (!switchers.length) return;

  switchers.forEach(function (switcher) {
    var items = Array.prototype.slice.call(switcher.querySelectorAll('[data-making-media-item]'));
    var thumbs = Array.prototype.slice.call(switcher.querySelectorAll('[data-making-media-thumb]'));
    if (!items.length || !thumbs.length) return;
    var activeIndex = 0;
    var autoTimer = null;
    var autoDelay = 3400;

    function setActive(id) {
      activeIndex = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('data-making-media-thumb') === id;
      });

      items.forEach(function (item) {
        var isActive = item.getAttribute('data-making-media-item') === id;
        item.classList.toggle('is-active', isActive);
        var video = item.querySelector('video');
        if (video) {
          if (isActive && !reducedMotion.matches) {
            video.currentTime = 0;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        }
      });

      thumbs.forEach(function (thumb) {
        var isActive = thumb.getAttribute('data-making-media-thumb') === id;
        thumb.classList.toggle('is-active', isActive);
      });
    }

    function clearAutoTimer() {
      if (!autoTimer) return;
      window.clearInterval(autoTimer);
      autoTimer = null;
    }

    function startAutoTimer() {
      clearAutoTimer();
      if (reducedMotion.matches || document.hidden) return;
      autoTimer = window.setInterval(function () {
        if (!thumbs.length) return;
        activeIndex = (activeIndex + 1) % thumbs.length;
        setActive(thumbs[activeIndex].getAttribute('data-making-media-thumb'));
      }, autoDelay);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(thumb.getAttribute('data-making-media-thumb'));
        startAutoTimer();
      });
    });

    switcher.addEventListener('mouseenter', clearAutoTimer);
    switcher.addEventListener('mouseleave', startAutoTimer);
    reducedMotion.addEventListener('change', function () {
      startAutoTimer();
      if (reducedMotion.matches) switcher.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    document.addEventListener('visibilitychange', startAutoTimer);

    var activeThumb = switcher.querySelector('[data-making-media-thumb].is-active');
    setActive(activeThumb ? activeThumb.getAttribute('data-making-media-thumb') : thumbs[0].getAttribute('data-making-media-thumb'));
    startAutoTimer();
  });
}

function initFooterBannerPicker() {
  var picker = document.querySelector('[data-footer-banner-picker]');
  var strip = document.querySelector('[data-footer-banner-strip]');
  if (!picker || !strip) return;

  var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-footer-banner-button]'));
  var options = Array.prototype.slice.call(strip.querySelectorAll('[data-footer-banner-option]'));
  if (!buttons.length || !options.length) return;

  function setActive(id) {
    buttons.forEach(function (button) {
      var isActive = button.getAttribute('data-footer-banner-button') === id;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    options.forEach(function (option) {
      option.classList.toggle('is-active', option.getAttribute('data-footer-banner-option') === id);
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      setActive(button.getAttribute('data-footer-banner-button'));
    });
  });
}

/* ═══════════════════════════════════════════════
   2. NAVIGATION
   ═══════════════════════════════════════════════ */

function initNavigation() {
  var nav = document.getElementById('prelaunch-nav');
  if (!nav) return;

  var hamburger = document.getElementById('nav-hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobilePanels = mobileMenu ? mobileMenu.querySelectorAll('[data-mobile-panel]') : [];
  var lastMenuTrigger = null;
  var menuOpen = false;
  var scrollThreshold = 60;
  var navIsScrolled = false;
  var navIsAtTop = true;
  var navOffsetRaf = null;

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return !element.hasAttribute('hidden') && element.offsetParent !== null;
      });
  }

  function updateDesktopDropdownState(item, expanded) {
    var trigger = item ? item.querySelector('.nav-link[aria-haspopup="true"]') : null;
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function handleMenuKeydown(event) {
    if (!menuOpen || !mobileMenu) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (event.key !== 'Tab') return;

    var activePanel = mobileMenu.querySelector('.mobile-menu__panel.is-active') || mobileMenu;
    var focusable = getFocusableElements(activePanel);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function syncNavOffset() {
    document.body.style.setProperty('--site-nav-offset', nav.getBoundingClientRect().height + 'px');
  }

  function requestNavOffsetSync() {
    if (navOffsetRaf) window.cancelAnimationFrame(navOffsetRaf);
    navOffsetRaf = window.requestAnimationFrame(function () {
      navOffsetRaf = null;
      syncNavOffset();
    });
  }

  function syncNavOffsetAfterTransition() {
    requestNavOffsetSync();
    window.setTimeout(requestNavOffsetSync, 120);
    window.setTimeout(requestNavOffsetSync, 360);
    window.setTimeout(requestNavOffsetSync, 680);
  }

  function syncNavScrollState() {
    var currentScrollY = Math.max(window.scrollY || 0, 0);
    // Hysteresis avoids header flicker around a single scroll threshold.
    var isScrolled = navIsScrolled ? currentScrollY > 40 : currentScrollY > scrollThreshold;
    var isAtTop = currentScrollY <= 120;


    if (isAtTop !== navIsAtTop) {
      navIsAtTop = isAtTop;
      nav.classList.toggle('nav-at-top', isAtTop);
      syncNavOffsetAfterTransition();
    }

    if (isScrolled === navIsScrolled) {
      requestNavOffsetSync();
      return;
    }
    navIsScrolled = isScrolled;
    nav.classList.toggle('nav-scrolled', isScrolled);
    syncNavOffsetAfterTransition();
  }

  function setMenuLock(locked) {
    document.documentElement.classList.toggle('is-mobile-menu-open', locked);
    document.body.classList.toggle('is-mobile-menu-open', locked);
  }

  function setMobileAccordionState(item, expanded) {
    if (!item) return;

    var toggle = item.querySelector('[data-mobile-accordion-toggle]');
    var panel = item.querySelector('[data-mobile-accordion-panel]');

    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    item.classList.toggle('is-open', expanded);

    if (panel) {
      panel.classList.toggle('is-open', expanded);
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      if (expanded) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }
  }

  function resetMobilePanels() {
    if (!mobileMenu) return;

    mobilePanels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-mobile-panel') === 'root');
    });

    mobileMenu.querySelectorAll('[data-mobile-accordion]').forEach(function (item) {
      var expanded = item.hasAttribute('data-mobile-accordion-default-open');
      setMobileAccordionState(item, expanded);
    });
  }

  function closeMenu() {
    menuOpen = false;
    setAnimatedSurfaceState(mobileMenu, false, function () {
      resetMobilePanels();
      if (!menuOpen) setMenuLock(false);
    });
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
      var hamburgerIcon = hamburger.querySelector('.hamburger-icon');
      var closeIcon = hamburger.querySelector('.close-icon');
      if (hamburgerIcon) hamburgerIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
    }
    document.removeEventListener('keydown', handleMenuKeydown);
    if (lastMenuTrigger && typeof lastMenuTrigger.focus === 'function') {
      lastMenuTrigger.focus();
    }
    requestNavOffsetSync();
  }

  function openMenu() {
    menuOpen = true;
    lastMenuTrigger = hamburger || document.activeElement;
    var wasHidden = mobileMenu && (mobileMenu.hidden || mobileMenu.style.display === 'none');
    setAnimatedSurfaceState(mobileMenu, true);
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'true');
      var hamburgerIcon = hamburger.querySelector('.hamburger-icon');
      var closeIcon = hamburger.querySelector('.close-icon');
      if (hamburgerIcon) hamburgerIcon.style.display = 'none';
      if (closeIcon) closeIcon.style.display = 'block';
    }
    setMenuLock(true);
    if (wasHidden) resetMobilePanels();
    document.addEventListener('keydown', handleMenuKeydown);
    window.requestAnimationFrame(function () {
      if (!menuOpen) return;
      var focusable = getFocusableElements(mobileMenu.querySelector('.mobile-menu__panel.is-active') || mobileMenu);
      if (focusable[0]) focusable[0].focus();
    });
    requestNavOffsetSync();
  }

  if (hamburger && mobileMenu) {
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.inert = true;
    mobileMenu.setAttribute('role', 'dialog');
    mobileMenu.setAttribute('aria-label', 'Navigation');
    hamburger.addEventListener('click', function () {
      if (menuOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (mobileMenu) {
    mobileMenu.querySelectorAll('[data-mobile-panel-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var target = trigger.getAttribute('data-mobile-panel-open');
        mobilePanels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-mobile-panel') === target);
        });
      });
    });

    mobileMenu.querySelectorAll('[data-mobile-panel-back]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        resetMobilePanels();
      });
    });

    mobileMenu.querySelectorAll('[data-mobile-accordion-toggle]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-mobile-accordion]');
        var nextOpen = trigger.getAttribute('aria-expanded') !== 'true';
        setMobileAccordionState(item, nextOpen);
      });
    });

    mobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('a') || event.target.closest('[data-search-toggle]') || event.target.closest('[data-cart-toggle]')) {
        closeMenu();
      }
    });
  }

  nav.querySelectorAll('.nav-item--has-children').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      updateDesktopDropdownState(item, true);
    });
    item.addEventListener('mouseleave', function () {
      updateDesktopDropdownState(item, false);
    });
    item.addEventListener('focusin', function () {
      updateDesktopDropdownState(item, true);
    });
    item.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () {
        if (!item.contains(document.activeElement)) {
          updateDesktopDropdownState(item, false);
        }
      });
    });
  });

  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 1024px)').matches && menuOpen) {
      closeMenu();
    }
    syncNavOffsetAfterTransition();
  });
  window.addEventListener('scroll', syncNavScrollState, { passive: true });
  if ('ResizeObserver' in window) {
    var navOffsetObserver = new ResizeObserver(requestNavOffsetSync);
    navOffsetObserver.observe(nav);
    var navBar = nav.querySelector('.nav-bar');
    if (navBar) navOffsetObserver.observe(navBar);
  }
  window.addEventListener('load', syncNavOffsetAfterTransition);
  window.requestAnimationFrame(syncNavOffsetAfterTransition);
  window.requestAnimationFrame(syncNavScrollState);

  // Smooth scroll to waitlist
  document.querySelectorAll('.scroll-to-waitlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var waitlist = document.getElementById('waitlist');
      if (waitlist) {
        e.preventDefault();
        if (menuOpen) closeMenu();
        waitlist.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  });
}

function initCommerceSheets() {
  var drawers = {
    search: document.querySelector('[data-commerce-drawer="search"]'),
    cart: document.querySelector('[data-commerce-drawer="cart"]')
  };
  var searchForm = document.querySelector('[data-search-drawer-form]');
  var searchInput = document.querySelector('[data-search-drawer-input]');
  var searchResults = document.querySelector('[data-search-drawer-results]');
  var activeDrawer = null;
  var focusBeforeOpen = null;
  var searchTimer = null;
  var baseCurrencyCode = window.themeMoneyBaseCurrency || 'INR';
  var displayRates = Object.assign({
    INR: 1,
    USD: 0.010493905,
    EUR: 0.0089787882,
    GBP: 0.0077587145
  }, window.themeDisplayRates || {});
  var supportedDisplayCurrencies = ['INR', 'USD', 'EUR', 'GBP'];
  var displayCurrencySelect = document.querySelector('[data-display-currency-select]');
  var displayCurrencyStorageKey = 'theme-display-currency-v2';
  var autoDisplayCurrencyStorageKey = 'theme-display-currency-auto-v2';
  var europeCurrencyCountries = [
    'AD', 'AL', 'AT', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ', 'DE', 'DK',
    'EE', 'ES', 'FI', 'FO', 'FR', 'GI', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT',
    'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL',
    'PT', 'RO', 'RS', 'SE', 'SI', 'SK', 'SM', 'UA', 'VA', 'XK'
  ];
  var activeCurrencyCode = getInitialDisplayCurrency();
  if (!drawers.search && !drawers.cart) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function getCartItemImage(item) {
    var imageUrl = item && item.image && item.image.url ? item.image.url : item && item.image;
    return {
      url: imageUrl || '',
      alt: item && item.product_title ? item.product_title : '',
      isDesignerPreview: false
    };
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return !element.hasAttribute('hidden') && element.offsetParent !== null;
      });
  }

  function normalizeDisplayCurrency(currencyCode) {
    var normalized = String(currencyCode || '').toUpperCase();
    return supportedDisplayCurrencies.indexOf(normalized) !== -1 ? normalized : '';
  }

  function getStoredDisplayCurrency(key) {
    try {
      return normalizeDisplayCurrency(window.localStorage.getItem(key) || window.sessionStorage.getItem(key));
    } catch (error) {
      return '';
    }
  }

  function countryToDisplayCurrency(countryCode) {
    var country = String(countryCode || '').toUpperCase();

    if (country === 'IN') return 'INR';
    if (country === 'GB') return 'GBP';
    if (europeCurrencyCountries.indexOf(country) !== -1) return 'EUR';
    return country ? 'USD' : '';
  }

  function detectCurrencyFromBrowserLocale() {
    var locales = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];

    for (var i = 0; i < locales.length; i += 1) {
      var parts = String(locales[i] || '').split('-');
      var region = parts.length > 1 ? parts[parts.length - 1] : '';
      var currency = countryToDisplayCurrency(region);
      if (currency) return currency;
    }

    return '';
  }

  function getInitialDisplayCurrency() {
    var manualCurrency = getStoredDisplayCurrency(displayCurrencyStorageKey);
    var autoCurrency = getStoredDisplayCurrency(autoDisplayCurrencyStorageKey);
    var liquidCountryCurrency = countryToDisplayCurrency(window.themeLocalization && window.themeLocalization.countryCode);

    return manualCurrency || autoCurrency || liquidCountryCurrency || normalizeDisplayCurrency(window.themeMoneyCurrency) || 'INR';
  }

  function formatMoney(cents, currencyCode) {
    var resolvedCurrency = currencyCode || activeCurrencyCode || window.themeMoneyCurrency || 'INR';
    var resolvedLocale = window.themeMoneyLocale || document.documentElement.lang || 'en';
    var baseValue = Number(cents || 0) / 100;
    var baseRate = Number(displayRates[baseCurrencyCode] || 1);
    var targetRate = Number(displayRates[resolvedCurrency] || 1);
    var value = Math.round((baseValue * (targetRate / baseRate)) / 5) * 5;

    if (window.Intl && typeof window.Intl.NumberFormat === 'function') {
      try {
        return new window.Intl.NumberFormat(resolvedLocale, {
          style: 'currency',
          currency: resolvedCurrency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(value);
      } catch (error) {}
    }

    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var amountNoDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var symbolMap = {
      INR: 'Rs. ',
      USD: '$',
      EUR: 'EUR ',
      GBP: 'GBP '
    };

    return (symbolMap[resolvedCurrency] || (resolvedCurrency + ' ')) + amountNoDecimals;
  }

  function formatDisplayPriceText(text) {
    return String(text || '').replace(/(?:₹|INR|Rs\.?)\s*([0-9][0-9,]*(?:\.\d+)?)/gi, function (_match, amount) {
      var rupees = Number(String(amount).replace(/,/g, ''));
      if (!Number.isFinite(rupees)) return _match;
      return formatMoney(Math.round(rupees * 100));
    });
  }

  function refreshInlinePriceText(root) {
    (root || document).querySelectorAll('[data-display-price-text]').forEach(function (element) {
      if (!element.dataset.basePriceText) element.dataset.basePriceText = element.textContent || '';
      element.textContent = formatDisplayPriceText(element.dataset.basePriceText);
    });
  }

  function refreshMoneyDisplays(root) {
    (root || document).querySelectorAll('[data-money-cents]').forEach(function (element) {
      var cents = Number(element.getAttribute('data-money-cents') || 0);
      element.textContent = formatMoney(cents);
    });
    refreshInlinePriceText(root);
  }

  var recentlyViewedStorageKey = 'theme-recently-viewed-products-v1';

  function readRecentlyViewedProducts() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(recentlyViewedStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.id && item.title && item.url;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecentlyViewedProducts(items) {
    try {
      window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(items.slice(0, 8)));
    } catch (error) {}
  }

  function trackCurrentProduct() {
    var product = window.themeCurrentProduct;
    if (!product || !product.id || !product.title || !product.url) return;

    var items = readRecentlyViewedProducts().filter(function (item) {
      return String(item.id) !== String(product.id) && item.url !== product.url;
    });

    items.unshift({
      id: product.id,
      title: product.title,
      url: product.url,
      price: Number(product.price || 0),
      image: product.image || ''
    });

    writeRecentlyViewedProducts(items);
  }

  function renderRecentlyViewed(root) {
    (root || document).querySelectorAll('[data-recently-viewed]').forEach(function (section) {
      var grid = section.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;

      var seen = {};
      var items = readRecentlyViewedProducts().filter(function (item) {
        var key = item.url ? String(item.url) : String(item.id || '');
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 3);
      if (!items.length) {
        section.hidden = true;
        grid.innerHTML = '';
        return;
      }

      grid.innerHTML = items.map(function (item) {
        var imageHtml = item.image ?
          '<img class="commerce-recently-viewed__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' :
          '<span class="commerce-recently-viewed__image commerce-recently-viewed__image--placeholder"></span>';
        var priceHtml = item.price ? '<span class="commerce-recently-viewed__price" data-money-cents="' + escapeHtml(item.price) + '">' + formatMoney(item.price) + '</span>' : '';

        return '' +
          '<a class="commerce-recently-viewed__card" href="' + escapeHtml(item.url) + '">' +
            '<span class="commerce-recently-viewed__media">' + imageHtml + '</span>' +
            '<span class="commerce-recently-viewed__body">' +
              '<span class="commerce-recently-viewed__name">' + escapeHtml(item.title) + '</span>' +
              priceHtml +
            '</span>' +
          '</a>';
      }).join('');
      section.hidden = false;
    });
  }

  function syncDisplayCurrencySelect() {
    if (!displayCurrencySelect) return;
    displayCurrencySelect.value = activeCurrencyCode;
  }

  function setActiveCurrency(currencyCode, options) {
    var normalized = normalizeDisplayCurrency(currencyCode);
    if (!normalized) return;

    activeCurrencyCode = normalized;
    window.themeMoneyCurrency = normalized;

    if (options && options.persistManual) {
      try {
        window.localStorage.setItem(displayCurrencyStorageKey, normalized);
        window.sessionStorage.removeItem(autoDisplayCurrencyStorageKey);
      } catch (error) {}
    } else if (options && options.persistAuto) {
      try {
        window.sessionStorage.setItem(autoDisplayCurrencyStorageKey, normalized);
      } catch (error) {}
    }

    syncDisplayCurrencySelect();
    refreshMoneyDisplays(document);
  }

  window.themeFormatDisplayMoney = formatMoney;
  window.themeRefreshDisplayMoney = refreshMoneyDisplays;

  function applyRatePayload(payload) {
    if (!payload) return;

    supportedDisplayCurrencies.forEach(function (currencyCode) {
      var rate = Number(
        payload.rates && payload.rates[currencyCode] ||
        payload.inr && payload.inr[currencyCode.toLowerCase()]
      );
      if (currencyCode !== 'INR' && rate > 0) displayRates[currencyCode] = rate;
    });

    displayRates.INR = 1;
    refreshMoneyDisplays(document);
  }

  function refreshDisplayRates() {
    if (!window.themeDisplayRateUrl || !window.fetch) return Promise.resolve();

    return fetch(window.themeDisplayRateUrl, {
      credentials: 'omit',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Display rate lookup failed');
        return response.json();
      })
      .then(applyRatePayload)
      .catch(function () {});
  }

  function setAutoCurrencyFromCountry(countryCode) {
    var currencyCode = countryToDisplayCurrency(countryCode);
    if (!currencyCode) return false;

    setActiveCurrency(currencyCode, { persistAuto: true });
    return true;
  }

  function extractSuggestedCountry(payload) {
    if (!payload) return '';

    if (payload.detected_values && payload.detected_values.country && payload.detected_values.country.handle) {
      return payload.detected_values.country.handle;
    }

    if (payload.suggestions && payload.suggestions.length) {
      for (var i = 0; i < payload.suggestions.length; i += 1) {
        var country = payload.suggestions[i] && payload.suggestions[i].parts && payload.suggestions[i].parts.country;
        if (country && country.handle) return country.handle;
      }
    }

    return '';
  }

  function detectCountryWithShopify() {
    if (!window.fetch) return Promise.resolve('');

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var currentCountry = window.themeLocalization && window.themeLocalization.countryCode ? window.themeLocalization.countryCode : '';
    var suggestionsUrl = root + 'browsing_context_suggestions.json?country%5Benabled%5D=true&country%5Bexclude%5D=' + encodeURIComponent(currentCountry) + '&language%5Benabled%5D=false';

    return fetch(suggestionsUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Shopify country lookup failed');
        return response.json();
      })
      .then(extractSuggestedCountry)
      .catch(function () {
        return '';
      });
  }

  function detectCountryWithFallbackApi() {
    if (!window.fetch) return Promise.resolve('');

    return fetch('https://api.country.is/', {
      credentials: 'omit',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Fallback country lookup failed');
        return response.json();
      })
      .then(function (payload) {
        return payload && payload.country ? payload.country : '';
      })
      .catch(function () {
        return '';
      });
  }

  function initDisplayCurrency() {
    syncDisplayCurrencySelect();

    if (displayCurrencySelect) {
      displayCurrencySelect.addEventListener('change', function () {
        setActiveCurrency(displayCurrencySelect.value, { persistManual: true });
      });
    }

    refreshDisplayRates();

    if (getStoredDisplayCurrency(displayCurrencyStorageKey)) return;

    detectCountryWithShopify()
      .then(function (countryCode) {
        if (countryCode && setAutoCurrencyFromCountry(countryCode)) return true;

        return detectCountryWithFallbackApi().then(function (fallbackCountryCode) {
          return fallbackCountryCode && setAutoCurrencyFromCountry(fallbackCountryCode);
        });
      })
      .then(function (didSetCurrency) {
        if (didSetCurrency) return;

        var browserCurrency = detectCurrencyFromBrowserLocale();
        if (browserCurrency) setActiveCurrency(browserCurrency, { persistAuto: true });
      })
      .catch(function () {});
  }

  function setCartCount(count) {
    var normalizedCount = Math.max(0, Number(count) || 0);
    var isEmpty = normalizedCount === 0;

    document.querySelectorAll('.nav-cart-count').forEach(function (badge) {
      badge.textContent = String(normalizedCount);
      badge.classList.toggle('is-empty', isEmpty);
      badge.hidden = isEmpty;
      if (isEmpty) {
        badge.setAttribute('aria-hidden', 'true');
      } else {
        badge.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll('.mobile-menu__utilities a[href="' + window.themeRoutes.cart + '"]').forEach(function (link) {
      link.textContent = normalizedCount ? 'Cart (' + normalizedCount + ')' : 'Cart';
    });
    document.querySelectorAll('.nav-icon-link--cart').forEach(function (link) {
      link.setAttribute('aria-label', normalizedCount ? 'Cart, ' + normalizedCount + (normalizedCount === 1 ? ' item' : ' items') : 'Cart');
    });
  }

  function lockScroll(locked) {
    document.documentElement.classList.toggle('is-commerce-drawer-open', locked);
    document.body.classList.toggle('is-commerce-drawer-open', locked);
  }

  function closeDrawer() {
    if (!activeDrawer) return;

    var closingDrawer = activeDrawer;
    var returnFocus = focusBeforeOpen;
    activeDrawer = null;
    focusBeforeOpen = null;
    setAnimatedSurfaceState(closingDrawer, false, function () {
      if (!activeDrawer) lockScroll(false);
    });
    document.removeEventListener('keydown', onKeyDown);

    if (returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus();
    }
  }

  function openDrawer(name, trigger, alreadyRefreshed) {
    var drawer = drawers[name];
    if (!drawer) return;

    if (activeDrawer && activeDrawer !== drawer) {
      closeDrawer();
    }

    focusBeforeOpen = trigger || document.activeElement;
    activeDrawer = drawer;
    setAnimatedSurfaceState(drawer, true);
    lockScroll(true);
    document.addEventListener('keydown', onKeyDown);

    window.requestAnimationFrame(function () {
      if (activeDrawer !== drawer || !drawer.classList.contains('is-visible')) return;

      var focusTarget = drawer.querySelector(name === 'search' ? '[data-search-drawer-input]' : '.commerce-drawer__panel');
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    });

    if (name === 'cart' && !alreadyRefreshed) {
      refreshCartDrawer();
    }
  }

  function submitCartCheckoutForm(form) {
    if (!form) {
      window.location.href = window.themeRoutes.checkout;
      return;
    }

    var checkoutInput = form.querySelector('input[name="checkout"][data-terms-checkout-input]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      checkoutInput.setAttribute('data-terms-checkout-input', 'true');
      form.appendChild(checkoutInput);
    }

    form.submit();
  }

  function onKeyDown(event) {
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab' || !activeDrawer) return;

    var panel = activeDrawer.querySelector('.commerce-drawer__panel');
    var focusable = getFocusableElements(panel);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.querySelectorAll('[data-commerce-close]').forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('[data-search-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer('search', trigger);
    });
  });

  document.querySelectorAll('[data-cart-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer('cart', trigger);
    });
  });

  function renderCartDrawer(cart) {
    var cartBody = document.querySelector('[data-cart-drawer-body]');
    if (!cartBody) return;

    setCartCount(cart.item_count || 0);
    var status = document.querySelector('[data-cart-drawer-status]');
    if (status) {
      status.textContent = (cart.item_count || 0) === 1
        ? 'Cart updated. 1 piece in your bag.'
        : 'Cart updated. ' + (cart.item_count || 0) + ' pieces in your bag.';
    }

    if (!cart.items || !cart.items.length) {
      cartBody.innerHTML =
        '<div class="commerce-empty-state commerce-empty-state--drawer" data-cart-empty-state>' +
          '<p>' + escapeHtml(window.themeCartStrings.emptyCopy) + '</p>' +
          '<a href="' + escapeHtml(window.themeRoutes.allProducts) + '" class="btn btn--solid">' + escapeHtml(window.themeCartStrings.emptyCta) + '</a>' +
          '<section class="commerce-recently-viewed commerce-recently-viewed--drawer" data-recently-viewed hidden aria-labelledby="drawer-recently-viewed-title-dynamic">' +
            '<div class="commerce-recently-viewed__header">' +
              '<p class="commerce-recently-viewed__eyebrow">Recently viewed</p>' +
              '<h2 id="drawer-recently-viewed-title-dynamic" class="commerce-recently-viewed__title">You were just looking at</h2>' +
            '</div>' +
            '<div class="commerce-recently-viewed__grid" data-recently-viewed-grid></div>' +
          '</section>' +
        '</div>';
      renderRecentlyViewed(cartBody);
      return;
    }

    function renderCartItemProperties(item) {
      var properties = item.properties || {};
      var propertyRows = [];

      Object.keys(properties).forEach(function (key) {
        var value = properties[key];
        if (!value || key.charAt(0) === '_') return;

        var valueString = Array.isArray(value) ? value.join(', ') : String(value);
        var valueHtml = valueString.indexOf('/uploads/') !== -1 ?
          '<a href="' + escapeHtml(valueString) + '" target="_blank" rel="noopener">' + escapeHtml('View upload') + '</a>' :
          escapeHtml(valueString);

        propertyRows.push(
          '<div>' +
            '<dt>' + escapeHtml(key) + ':</dt>' +
            '<dd>' + valueHtml + '</dd>' +
          '</div>'
        );
      });

      if (!propertyRows.length) return '';
      return '<dl class="commerce-drawer-item__properties">' + propertyRows.join('') + '</dl>';
    }

    var itemsHtml = cart.items.map(function (item, index) {
      var cartImage = getCartItemImage(item);
      var imageClass = 'commerce-drawer-item__image' + (cartImage.isDesignerPreview ? ' commerce-drawer-item__image--designer-preview' : '');
      var imageHtml = cartImage.url ?
        '<img class="' + imageClass + '" src="' + escapeHtml(cartImage.url) + '" alt="' + escapeHtml(cartImage.alt || item.product_title) + '" loading="lazy">' :
        '<div class="commerce-drawer-item__image commerce-drawer-item__image--placeholder"></div>';

      return '' +
        '<article class="commerce-drawer-item" data-cart-item>' +
          '<a href="' + escapeHtml(item.url) + '" class="commerce-drawer-item__media">' + imageHtml + '</a>' +
          '<div class="commerce-drawer-item__content">' +
            '<div class="commerce-drawer-item__header">' +
              '<div>' +
                '<h3 class="commerce-drawer-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h3>' +
                (item.variant_title ? '<p class="commerce-drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
              '</div>' +
              '<p class="commerce-drawer-item__price" data-money-cents="' + escapeHtml(item.final_line_price) + '">' + formatMoney(item.final_line_price) + '</p>' +
            '</div>' +
            renderCartItemProperties(item) +
            '<div class="commerce-drawer-item__footer">' +
              '<label class="commerce-drawer-item__qty">' +
                '<span>' + escapeHtml(window.themeCartStrings.quantity) + '</span>' +
                '<input type="number" min="0" value="' + escapeHtml(item.quantity) + '" data-cart-quantity-input data-line="' + (index + 1) + '">' +
              '</label>' +
              '<button class="commerce-drawer-item__remove" type="button" data-cart-remove data-line="' + (index + 1) + '">' + escapeHtml(window.themeCartStrings.remove) + '</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');

    cartBody.innerHTML =
      '<div class="commerce-drawer__stack">' +
        '<div class="commerce-drawer__items" data-cart-drawer-items>' + itemsHtml + '</div>' +
        '<div class="commerce-drawer__footer" data-cart-drawer-footer>' +
          '<div class="commerce-drawer__summary">' +
            '<p class="commerce-drawer__summary-label">' + escapeHtml(window.themeCartStrings.subtotal) + '</p>' +
            '<p class="commerce-drawer__summary-total" data-money-cents="' + escapeHtml(cart.total_price) + '">' + formatMoney(cart.total_price) + '</p>' +
          '</div>' +
          '<p class="commerce-cart-reassurance">' + escapeHtml(window.themeCartStrings.taxShippingNote || 'Inclusive of all taxes · Free shipping') + '</p>' +
          '<div class="commerce-drawer__actions">' +
            '<a href="' + escapeHtml(window.themeRoutes.checkout) + '" class="btn btn--solid btn--full" data-cart-checkout-link>' + escapeHtml(window.themeCartStrings.checkout) + '</a>' +
            '<a href="' + escapeHtml(window.themeRoutes.cart) + '" class="commerce-inline-link commerce-inline-link--centered">' + escapeHtml(window.themeCartStrings.viewCart) + '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function refreshCartDrawer() {
    if (!drawers.cart) return Promise.resolve();

    return fetch(window.themeRoutes.cart + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function updateCartLine(line, quantity) {
    return fetch(window.themeRoutes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
  }

  document.addEventListener('change', function (event) {
    var qtyInput = event.target.closest('[data-cart-quantity-input]');
    if (!qtyInput) return;

    var line = Number(qtyInput.getAttribute('data-line'));
    var quantity = Math.max(0, Number(qtyInput.value || 0));
    updateCartLine(line, quantity);
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      updateCartLine(Number(removeButton.getAttribute('data-line')), 0);
      return;
    }

    var checkoutLink = event.target.closest('[data-cart-checkout-link]');
    if (checkoutLink) {
      event.preventDefault();
      checkoutLink.setAttribute('href', window.themeRoutes.checkout);
      window.location.href = checkoutLink.getAttribute('href') || window.themeRoutes.checkout;
      return;
    }

    var checkoutButton = event.target.closest('[data-cart-checkout-button]');
    if (checkoutButton) {
      event.preventDefault();
      submitCartCheckoutForm(checkoutButton.form || checkoutButton.closest('form'));
    }
  });

  document.querySelectorAll('form[action*="/cart/add"], form[data-product-form]').forEach(function (form) {
    if (form.dataset.ajaxCartBound === '1') return;
    form.dataset.ajaxCartBound = '1';

    // Wishlist integrations sometimes change our submit control to type=button.
    // Keep the native theme purchase flow (and validation) authoritative without
    // intercepting any wishlist control or allowing two add-to-cart handlers.
    form.addEventListener('click', function (event) {
      var button = event.target.closest('[data-product-submit]');
      if (!button || button.form !== form || button.type !== 'button' || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      button.type = 'submit';
      try {
        form.requestSubmit(button);
      } finally {
        button.type = 'button';
      }
    }, true);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }

      var submitButton = event.submitter && event.submitter.matches && event.submitter.matches('[type="submit"]')
        ? event.submitter
        : form.querySelector('[type="submit"]');
      var submitLabel = submitButton ? submitButton.querySelector('[data-product-add-label]') : null;
      var originalText = submitLabel ? submitLabel.textContent : '';

      if (form.getAttribute('aria-busy') === 'true') return;
      form.setAttribute('aria-busy', 'true');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
      if (submitLabel) submitLabel.textContent = 'Adding…';

      fetch(window.themeRoutes.cartAdd + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return refreshCartDrawer();
        })
        .then(function () {
          openDrawer('cart', submitButton || form, true);
          var status = document.querySelector('[data-cart-drawer-status]');
          if (status) status.textContent = 'Your piece has been added to the cart.';
        })
        .catch(function () {
          window.location.href = window.themeRoutes.cart;
        })
        .finally(function () {
          form.removeAttribute('aria-busy');
          if (submitButton) submitButton.removeAttribute('aria-busy');
          if (submitButton) submitButton.disabled = false;
          if (submitLabel) submitLabel.textContent = originalText || 'Add to cart';
        });
    });
  });

  function renderSearchResults(payload, query) {
    if (!searchResults) return;

    var resources = payload && payload.resources && payload.resources.results ? payload.resources.results : null;
    if (!resources) {
      searchResults.innerHTML =
        '<div class="commerce-empty-state commerce-empty-state--drawer commerce-empty-state--soft">' +
          '<p class="commerce-empty-state__eyebrow">Search</p>' +
          '<p>' + escapeHtml(window.themeCartStrings.searchPromptCopy) + '</p>' +
        '</div>';
      return;
    }

    var products = resources.products || [];

    if (!products.length) {
      searchResults.innerHTML =
        '<div class="commerce-empty-state commerce-empty-state--drawer">' +
          '<p class="commerce-empty-state__eyebrow">Search</p>' +
          '<p>' + escapeHtml(window.themeCartStrings.searchEmptyCopyPrefix) + ' “' + escapeHtml(query) + '”.</p>' +
        '</div>';
      return;
    }

    function renderSearchCard(item) {
      var imageUrl = item.image && item.image.url ? item.image.url : item.image;
      var image = imageUrl ?
        '<img class="commerce-drawer-item__image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' :
        '<div class="commerce-drawer-item__image commerce-drawer-item__image--placeholder"></div>';

      var priceHtml = '';
      var rawSearchPrice = item.price && item.price.min_variant_price ? item.price.min_variant_price.amount : '';
      var numericSearchPrice = Number(rawSearchPrice);
      if (Number.isFinite(numericSearchPrice) && numericSearchPrice > 0) {
        priceHtml = '<p class="commerce-drawer-item__price" data-money-cents="' + escapeHtml(Math.round(numericSearchPrice * 100)) + '">' + formatMoney(Math.round(numericSearchPrice * 100)) + '</p>';
      } else if (rawSearchPrice) {
        priceHtml = '<p class="commerce-drawer-item__price">' + escapeHtml(rawSearchPrice) + '</p>';
      }

      return '' +
        '<article class="commerce-drawer-item commerce-drawer-item--search">' +
          '<a href="' + escapeHtml(item.url) + '" class="commerce-drawer-item__media">' + image + '</a>' +
          '<div class="commerce-drawer-item__content">' +
            '<div class="commerce-drawer-item__header">' +
              '<div>' +
                '<p class="commerce-drawer-item__eyebrow">Piece</p>' +
                '<h3 class="commerce-drawer-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
              '</div>' +
              priceHtml +
            '</div>' +
          '</div>' +
        '</article>';
    }

    var cards = products.slice(0, 8).map(function (item) { return renderSearchCard(item); });

    searchResults.innerHTML =
      '<div class="commerce-drawer__items commerce-drawer__items--search">' + cards.join('') + '</div>' +
      '<div class="commerce-search-drawer__footer">' +
        '<a href="' + escapeHtml(window.themeRoutes.search) + '?q=' + encodeURIComponent(query) + '&type=product" class="btn btn--solid btn--full">' + escapeHtml(window.themeCartStrings.searchViewAll) + '</a>' +
      '</div>';
  }

  function runPredictiveSearch(query) {
    if (!window.themeRoutes || !window.themeRoutes.predictiveSearch) return;

    var url = window.themeRoutes.predictiveSearch +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=8';

    fetch(url, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (payload) {
        renderSearchResults(payload, query);
      })
      .catch(function () {
        renderSearchResults(null, '');
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();

      window.clearTimeout(searchTimer);

      if (query.length < 2) {
        renderSearchResults(null, '');
        return;
      }

      searchTimer = window.setTimeout(function () {
        runPredictiveSearch(query);
      }, 180);
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      closeDrawer();
    });
  }

  initDisplayCurrency();
  trackCurrentProduct();
  refreshMoneyDisplays(document);
  renderRecentlyViewed(document);
  refreshCartDrawer();
}

/* ═══════════════════════════════════════════════
   3. WEAVING LOOM SVG ANIMATION
   ═══════════════════════════════════════════════ */

function initWeavingLoom() {
  var container = document.getElementById('weaving-loom-container');
  if (!container) return;

  var FABRIC_LEFT = 14;
  var TOTAL_COLS = 34;
  var COL_W = 14;
  var LOOM_W = FABRIC_LEFT + TOTAL_COLS * COL_W + 14;
  var LOOM_H = 220;
  var WARP_COUNT = 50;
  var WARP_SPACING = LOOM_H / (WARP_COUNT + 1);
  var SHUTTLE_CROSS_MS = 800;
  var COL_PAUSE_MS = 200;

  // Deliberate color bands — each brand color gets a visible stripe
  var WEFT_PALETTE = [
    // Orchid mist band (purple foundation)
    '#917799','#917799','#9E82A6','#917799',
    // Vibrant orange accent stripe
    '#FF741F','#FF741F','#FF741F',
    // Orchid bloom band (light purple)
    '#C4AFD1','#C4AFD1','#B89EC4','#C4AFD1',
    // Pickled beet accent stripe (deep maroon)
    '#4D243D','#4D243D','#4D243D',
    // Egret band (ivory/cream)
    '#F3EBE0','#E8DDD0','#F3EBE0','#E8DDD0',
    // Orchid mist return
    '#917799','#856D8E','#917799',
    // Orange accent return
    '#FF741F','#FF741F',
    // Blackberry cordial band (dark purple)
    '#422A47','#422A47','#422A47',
    // Orchid bloom fade out
    '#C4AFD1','#9E82A6','#917799','#856D8E',
    // Final ivory
    '#F3EBE0','#E8DDD0'
  ];

  function warpColor(i) {
    var mod = i % 6;
    if (mod === 0) return '#C4AFD1';
    if (mod === 1) return '#917799';
    if (mod === 2) return '#D8C8E0';
    if (mod === 3) return '#A68BAE';
    if (mod === 4) return '#C4AFD1';
    return '#B89EC4';
  }

  var ns = 'http://www.w3.org/2000/svg';

  function createSVG(tag, attrs) {
    var el = document.createElementNS(ns, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  var svg = createSVG('svg', {
    viewBox: '-12 -20 ' + (LOOM_W + 24) + ' ' + (LOOM_H + 40),
    style: 'overflow:visible; width:100%; max-width:580px; height:auto;',
    'aria-hidden': 'true',
    role: 'presentation'
  });
  container.appendChild(svg);

  // Defs
  var defs = createSVG('defs', {});
  var shuttleGrad = createSVG('linearGradient', { id: 'shuttleWood', x1: '0', y1: '0', x2: '1', y2: '0' });
  [['0%','#6B4520'],['25%','#8B6914'],['50%','#A07D28'],['75%','#8B6914'],['100%','#6B4520']].forEach(function(s) {
    var stop = createSVG('stop', { offset: s[0], 'stop-color': s[1] });
    shuttleGrad.appendChild(stop);
  });
  defs.appendChild(shuttleGrad);
  svg.appendChild(defs);

  // Loom frame
  svg.appendChild(createSVG('rect', { x: -8, y: -8, width: 10, height: LOOM_H + 16, rx: 4, fill: '#5C3A1E', opacity: 0.6 }));
  svg.appendChild(createSVG('rect', { x: -6, y: -8, width: 6, height: LOOM_H + 16, rx: 3, fill: '#7A5230', opacity: 0.4 }));
  svg.appendChild(createSVG('rect', { x: LOOM_W - 2, y: -8, width: 10, height: LOOM_H + 16, rx: 4, fill: '#5C3A1E', opacity: 0.6 }));
  svg.appendChild(createSVG('rect', { x: LOOM_W, y: -8, width: 6, height: LOOM_H + 16, rx: 3, fill: '#7A5230', opacity: 0.4 }));
  svg.appendChild(createSVG('rect', { x: -10, y: -16, width: LOOM_W + 20, height: 6, rx: 3, fill: '#6B4F10', opacity: 0.3 }));
  svg.appendChild(createSVG('rect', { x: -10, y: LOOM_H + 10, width: LOOM_W + 20, height: 6, rx: 3, fill: '#6B4F10', opacity: 0.3 }));

  // Reed/beater bar
  var reed = createSVG('rect', { x: FABRIC_LEFT, y: -10, width: 3, height: LOOM_H + 20, rx: 1.5, fill: '#8B6914', opacity: 0.5 });
  svg.appendChild(reed);

  // Warp threads
  var warpLines = [];
  for (var i = 0; i < WARP_COUNT; i++) {
    var y = WARP_SPACING * (i + 1);
    var line = createSVG('line', { x1: 0, y1: y, x2: LOOM_W, y2: y, stroke: warpColor(i), 'stroke-width': 1.1, 'stroke-opacity': 0.45 });
    svg.appendChild(line);
    warpLines.push({ el: line, baseY: y, isUpper: i % 2 === 0 });
  }

  // Fabric group
  var fabricGroup = createSVG('g', {});
  svg.appendChild(fabricGroup);

  // Shuttle group
  var shuttleG = createSVG('g', { style: 'display:none' });
  svg.appendChild(shuttleG);

  // Build shuttle shape
  var shuttleBody = createSVG('path', {
    d: 'M 10,2 C 3,8 0,22 0,32 C 0,42 3,56 10,62 C 17,56 20,42 20,32 C 20,22 17,8 10,2 Z',
    fill: 'url(#shuttleWood)', stroke: '#5C3A1E', 'stroke-width': 0.7
  });
  shuttleG.appendChild(createSVG('path', {
    d: 'M 10,2 C 3,8 0,22 0,32 C 0,42 3,56 10,62 C 17,56 20,42 20,32 C 20,22 17,8 10,2 Z',
    fill: '#000', opacity: 0.12, transform: 'translate(1.5,1.5)'
  }));
  shuttleG.appendChild(shuttleBody);
  shuttleG.appendChild(createSVG('path', { d: 'M 10,14 C 6,18 5,25 5,32 C 5,39 6,46 10,50 C 14,46 15,39 15,32 C 15,25 14,18 10,14 Z', fill: '#3D2010', opacity: 0.3 }));
  shuttleG.appendChild(createSVG('ellipse', { cx: 10, cy: 32, rx: 3.5, ry: 8, fill: '#6B4520', opacity: 0.6 }));
  var shuttleThread = createSVG('line', { x1: 10, y1: 32, x2: 10, y2: -10, stroke: '#917799', 'stroke-width': 1.2, 'stroke-linecap': 'round', opacity: 0.55 });
  shuttleG.appendChild(shuttleThread);
  shuttleG.appendChild(createSVG('path', { d: 'M 10,2 L 7,5 Q 10,4 13,5 Z', fill: '#C49A2A', opacity: 0.7 }));
  shuttleG.appendChild(createSVG('path', { d: 'M 10,62 L 7,59 Q 10,60 13,59 Z', fill: '#C49A2A', opacity: 0.7 }));

  // Cloth beam roll
  var clothBeam = createSVG('g', { opacity: 0, style: 'display:none' });
  clothBeam.appendChild(createSVG('ellipse', { cx: -2, cy: LOOM_H / 2, rx: 5, ry: LOOM_H * 0.35, fill: '#C49A2A' }));
  clothBeam.appendChild(createSVG('ellipse', { cx: -2, cy: LOOM_H / 2, rx: 3, ry: LOOM_H * 0.35, fill: '#5C3A1E' }));
  svg.appendChild(clothBeam);

  var wovenCols = 0;
  var cancelled = false;

  function setShed(open) {
    var amt = open ? 2.5 : 0;
    warpLines.forEach(function (w) {
      var off = w.isUpper ? -amt : amt;
      w.el.setAttribute('y1', w.baseY + off);
      w.el.setAttribute('y2', w.baseY + off);
    });
  }

  function drawWovenCol(col) {
    var cx = FABRIC_LEFT + col * COL_W + COL_W * 0.5;
    var color = WEFT_PALETTE[col % WEFT_PALETTE.length];
    var brightness = 1 + Math.sin(col * 0.7) * 0.06;
    var g = createSVG('g', {});
    var curve = WARP_SPACING * 0.15;
    var halfGap = WARP_SPACING * 0.48;

    for (var w = 0; w < WARP_COUNT; w++) {
      var wy = WARP_SPACING * (w + 1);
      var isOver = (w + col) % 2 === 0;
      var top = wy - halfGap;
      var bot = wy + halfGap;

      if (isOver) {
        g.appendChild(createSVG('path', {
          d: 'M ' + cx + ',' + top + ' Q ' + (cx + curve) + ',' + wy + ' ' + cx + ',' + bot,
          fill: 'none', stroke: color, 'stroke-width': COL_W * 0.75, 'stroke-linecap': 'round', opacity: 0.92 * brightness
        }));
      } else {
        g.appendChild(createSVG('path', {
          d: 'M ' + cx + ',' + top + ' Q ' + (cx - curve) + ',' + wy + ' ' + cx + ',' + bot,
          fill: 'none', stroke: color, 'stroke-width': COL_W * 0.6, 'stroke-linecap': 'round', opacity: 0.3 * brightness
        }));
      }
    }

    // Warp-over redraw
    for (var w2 = 0; w2 < WARP_COUNT; w2++) {
      var wy2 = WARP_SPACING * (w2 + 1);
      if ((w2 + col) % 2 === 0) continue;
      g.appendChild(createSVG('line', {
        x1: cx - COL_W * 0.55, y1: wy2, x2: cx + COL_W * 0.55, y2: wy2,
        stroke: warpColor(w2), 'stroke-width': 1.1, opacity: 0.65
      }));
    }

    fabricGroup.appendChild(g);
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function weaveCol(col) {
    if (cancelled) return;
    var goingDown = col % 2 === 0;
    var shuttleX = FABRIC_LEFT + col * COL_W + COL_W / 2;

    shuttleG.style.display = '';
    shuttleThread.setAttribute('stroke', WEFT_PALETTE[col % WEFT_PALETTE.length]);
    shuttleThread.setAttribute('y2', goingDown ? -10 : 74);
    setShed(true);

    var start = performance.now();
    function tick(now) {
      if (cancelled) return;
      var t = Math.min((now - start) / SHUTTLE_CROSS_MS, 1);
      var ease = easeInOutQuad(t);
      var y = goingDown ? ease * LOOM_H : LOOM_H * (1 - ease);
      shuttleG.setAttribute('transform', 'translate(' + (shuttleX - 10) + ',' + (y - 32) + ')');

      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        setShed(false);
        shuttleG.style.display = 'none';
        setTimeout(function () {
          if (cancelled) return;
          drawWovenCol(col);
          wovenCols = col + 1;
          reed.setAttribute('x', FABRIC_LEFT + wovenCols * COL_W - 1);

          if (wovenCols > 3) {
            clothBeam.style.display = '';
            clothBeam.setAttribute('opacity', '0.25');
          }

          if (col + 1 >= TOTAL_COLS) {
            setTimeout(function () {
              if (cancelled) return;
              while (fabricGroup.firstChild) fabricGroup.removeChild(fabricGroup.firstChild);
              wovenCols = 0;
              reed.setAttribute('x', FABRIC_LEFT);
              clothBeam.style.display = 'none';
              setTimeout(function () { weaveCol(0); }, 800);
            }, 2500);
          } else {
            setTimeout(function () { weaveCol(col + 1); }, COL_PAUSE_MS);
          }
        }, 150);
      }
    }
    requestAnimationFrame(tick);
  }

  function showStaticWeave() {
    cancelled = true;
    setShed(false);
    shuttleG.style.display = 'none';
    for (var col = wovenCols; col < TOTAL_COLS; col++) drawWovenCol(col);
    wovenCols = TOTAL_COLS;
    reed.setAttribute('x', FABRIC_LEFT + TOTAL_COLS * COL_W - 1);
  }
  var loomMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  loomMotionPreference.addEventListener('change', function (event) {
    if (event.matches && !cancelled) showStaticWeave();
  });
  if (loomMotionPreference.matches) {
    showStaticWeave();
    return;
  }

  // Start after delay, only when visible
  var loomObserver = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      loomObserver.disconnect();
      setTimeout(function () { weaveCol(0); }, 1600);
    }
  }, { threshold: 0.2 });
  loomObserver.observe(container);
}

/* ═══════════════════════════════════════════════
   4. COUNTDOWN TIMER
   ═══════════════════════════════════════════════ */

function initCountdown() {
  // Find all countdown timers on the page
  var timers = document.querySelectorAll('[data-launch]');
  if (!timers.length) return;

  timers.forEach(function (timer) {
    var launchStr = timer.getAttribute('data-launch') || '2026-05-05T00:00:00';
    var launchDate = new Date(launchStr).getTime();
    // Support both .countdown-value and .hero-countdown__value
    var values = timer.querySelectorAll('.countdown-value, .hero-countdown__value');
    if (!values.length) return;

    function update() {
      var now = Date.now();
      var diff = Math.max(0, launchDate - now);
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      var vals = [days, hours, minutes, seconds];

      values.forEach(function (el, i) {
        var newVal = String(vals[i]).padStart(2, '0');
        if (el.textContent !== newVal) {
          el.textContent = newVal;
          el.classList.remove('flip');
          void el.offsetWidth;
          el.classList.add('flip');
        }
      });
    }

    update();
    setInterval(update, 1000);
  });
}

/* ═══════════════════════════════════════════════
   5. SEQUENTIAL WORD REVEAL
   ═══════════════════════════════════════════════ */

function initSequentialWords() {
  var containers = document.querySelectorAll('.sequential-words');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var spans = container.querySelectorAll('span');
    spans.forEach(function (span, i) {
      span.style.opacity = '0';
      span.style.transform = 'translateY(30px)';
      span.style.transition = 'opacity 0.6s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.15) + 's, transform 0.6s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.15) + 's';
      span.style.display = 'inline-block';
    });

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        spans.forEach(function (span) {
          span.style.opacity = '1';
          span.style.transform = 'translateY(0)';
        });
        observer.disconnect();
      }
    }, { rootMargin: '-80px' });
    observer.observe(container);
  });
}

/* ═══════════════════════════════════════════════
   6. STAGGERED COLOR WORDS
   ═══════════════════════════════════════════════ */

function initStaggeredColorWords() {
  var containers = document.querySelectorAll('.staggered-color-words');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        container.classList.add('visible');
        observer.disconnect();
      }
    }, { rootMargin: '-100px' });
    observer.observe(container);
  });
}

/* ═══════════════════════════════════════════════
   7. SCROLL REVEAL TEXT
   ═══════════════════════════════════════════════ */

function initScrollRevealText() {
  var elements = document.querySelectorAll('.scroll-reveal-text');
  if (!elements.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '-100px' });

  elements.forEach(function (el) { observer.observe(el); });
}

/* ═══════════════════════════════════════════════
   8. PARALLAX IMAGES
   ═══════════════════════════════════════════════ */

function initParallax() {
  var elements = document.querySelectorAll('.parallax-image__inner, .editorial-break__image');
  if (!elements.length) return;

  function updateParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (el) { el.style.transform = ''; });
      return;
    }
    var scrollY = window.scrollY;
    var windowH = window.innerHeight;

    elements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var elTop = rect.top + scrollY;
      var elH = rect.height;
      var progress = (scrollY + windowH - elTop) / (windowH + elH);
      progress = Math.max(0, Math.min(1, progress));
      var translate = (progress - 0.5) * 20;
      el.style.transform = 'translateY(' + translate + '%)';
    });
  }

  window.addEventListener('scroll', updateParallax, { passive: true });
  updateParallax();
}

/* ═══════════════════════════════════════════════
   9. HOME HERO VIDEO
   ═══════════════════════════════════════════════ */

function initHomeHeroVideo() {
  var hero = document.querySelector('.video-hero');
  if (!hero) return;

  var video = hero.querySelector('.video-hero__media');
  var overlayPlay = hero.querySelector('.video-hero__play-overlay');
  var playBtn = hero.querySelector('.video-hero__toggle-play');
  var muteBtn = hero.querySelector('.video-hero__toggle-mute');
  var fullscreenBtn = hero.querySelector('.video-hero__toggle-fullscreen');
  var playBtnIcon = playBtn ? playBtn.querySelector('[data-video-hero-play-icon]') : null;
  var muteBtnIcon = muteBtn ? muteBtn.querySelector('[data-video-hero-mute-icon]') : null;
  var playIcon = playBtnIcon ? playBtnIcon.querySelector('.video-hero__icon-play') : null;
  var pauseIcon = playBtnIcon ? playBtnIcon.querySelector('.video-hero__icon-pause') : null;
  var volumeOnIcon = muteBtnIcon ? muteBtnIcon.querySelector('.video-hero__icon-volume-on') : null;
  var volumeOffIcon = muteBtnIcon ? muteBtnIcon.querySelector('.video-hero__icon-volume-off') : null;
  var playBtnLabel = playBtn ? playBtn.querySelector('.video-hero__control-label') : null;
  var muteBtnLabel = muteBtn ? muteBtn.querySelector('.video-hero__control-label') : null;
  var progress = hero.querySelector('.video-hero__progress');
  var volume = hero.querySelector('.video-hero__volume');
  var currentTimeEl = hero.querySelector('.video-hero__time-current');
  var durationEl = hero.querySelector('.video-hero__time-duration');
  var desktopSrc = video ? video.getAttribute('data-src-desktop') : '';
  var mobileSrc = video ? video.getAttribute('data-src-mobile') : '';
  var desktopPoster = video ? video.getAttribute('data-poster-desktop') : '';
  var mobilePoster = video ? video.getAttribute('data-poster-mobile') : '';

  if (!video || !muteBtn) return;

  var isSeeking = false;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var useMobileVideo = window.matchMedia('(max-width: 749px), (orientation: portrait)').matches;
  var initialSrc = useMobileVideo && mobileSrc ? mobileSrc : desktopSrc;
  var initialPoster = useMobileVideo && mobilePoster ? mobilePoster : desktopPoster;

  if (initialPoster) {
    video.poster = initialPoster;
  }

  if (initialSrc && video.getAttribute('src') !== initialSrc) {
    video.setAttribute('src', initialSrc);
    video.load();
  }

  if (hero.hasAttribute('data-video-hero-ambient')) {
    video.controls = false;
    video.defaultMuted = true;
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('autoplay', '');

    function updateAmbientMuteState() {
      var silent = video.muted || video.volume === 0;
      if (volumeOnIcon) volumeOnIcon.hidden = silent;
      if (volumeOffIcon) volumeOffIcon.hidden = !silent;
      if (muteBtnLabel) muteBtnLabel.textContent = silent ? 'Unmute' : 'Mute';
      muteBtn.setAttribute('aria-label', silent ? 'Unmute video' : 'Mute video');
    }

    function ensureAmbientPlaying() {
      if (reducedMotion.matches) {
        video.pause();
        hero.classList.remove('is-playing');
        return;
      }
      hero.classList.add('is-started', 'is-playing');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    muteBtn.addEventListener('click', function () {
      if (video.muted || video.volume === 0) {
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
      } else {
        video.muted = true;
      }
      updateAmbientMuteState();
      ensureAmbientPlaying();
    });

    video.addEventListener('volumechange', updateAmbientMuteState);
    video.addEventListener('loadeddata', ensureAmbientPlaying);
    video.addEventListener('canplay', ensureAmbientPlaying);
    reducedMotion.addEventListener('change', function (event) {
      if (event.matches) {
        video.pause();
        hero.classList.remove('is-playing');
      } else {
        ensureAmbientPlaying();
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ensureAmbientPlaying();
    });

    updateAmbientMuteState();
    ensureAmbientPlaying();
    return;
  }

  if (!playBtn || !fullscreenBtn || !progress || !volume) return;

  function formatTime(seconds) {
    if (!isFinite(seconds)) return '00:00';
    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  }

  function updatePlayState() {
    var isPlaying = !video.paused && !video.ended;
    hero.classList.toggle('is-playing', isPlaying);
    if (playIcon) playIcon.hidden = isPlaying;
    if (pauseIcon) pauseIcon.hidden = !isPlaying;
    if (playBtnLabel) playBtnLabel.textContent = isPlaying ? 'Pause' : 'Play';
    playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }

  function updateMuteState() {
    var silent = video.muted || video.volume === 0;
    if (volumeOnIcon) volumeOnIcon.hidden = !silent;
    if (volumeOffIcon) volumeOffIcon.hidden = silent;
    if (muteBtnLabel) muteBtnLabel.textContent = silent ? 'Unmute' : 'Mute';
    muteBtn.setAttribute('aria-label', silent ? 'Unmute video' : 'Mute video');
  }

  function updateTimeState() {
    if (!isSeeking && isFinite(video.duration) && video.duration > 0) {
      var progressValue = (video.currentTime / video.duration) * 100;
      progress.value = progressValue;
      progress.style.setProperty('--video-progress', progressValue + '%');
    }

    if (currentTimeEl) currentTimeEl.textContent = formatTime(video.currentTime);
    if (durationEl) durationEl.textContent = formatTime(video.duration);
  }

  function updateVolumeState() {
    var volumeValue = Math.max(0, Math.min(1, video.muted ? 0 : video.volume));
    volume.value = volumeValue;
    volume.style.setProperty('--video-volume', (volumeValue * 100) + '%');
    updateMuteState();
  }

  function dismissOverlay() {
    if (!overlayPlay) return;
    overlayPlay.hidden = true;
    overlayPlay.setAttribute('aria-hidden', 'true');
  }

  function requestPlay() {
    hero.classList.add('is-started');
    dismissOverlay();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (video.paused) {
          hero.classList.remove('is-started');
          overlayPlay.hidden = false;
          overlayPlay.removeAttribute('aria-hidden');
        }
      });
    }
  }

  if (video.hasAttribute('autoplay')) {
    video.removeAttribute('autoplay');
  }
  video.muted = false;
  video.volume = 1;
  video.controls = false;

  overlayPlay.addEventListener('click', function () {
    if (video.paused) {
      requestPlay();
    } else {
      video.pause();
    }
  });

  playBtn.addEventListener('click', function () {
    if (video.paused) {
      requestPlay();
    } else {
      video.pause();
    }
  });

  muteBtn.addEventListener('click', function () {
    if (video.muted || video.volume === 0) {
      video.muted = false;
      if (video.volume === 0) {
        video.volume = 1;
      }
    } else {
      video.muted = true;
    }
    updateVolumeState();
  });

  fullscreenBtn.addEventListener('click', function () {
    if (document.fullscreenElement === video || document.webkitFullscreenElement === video) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }

    if (video.requestFullscreen) video.requestFullscreen();
    else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
  });

  progress.addEventListener('input', function () {
    isSeeking = true;
    progress.style.setProperty('--video-progress', progress.value + '%');
    if (isFinite(video.duration) && video.duration > 0) {
      video.currentTime = (Number(progress.value) / 100) * video.duration;
    }
    updateTimeState();
  });

  progress.addEventListener('change', function () {
    isSeeking = false;
  });

  volume.addEventListener('input', function () {
    var nextVolume = Number(volume.value);
    video.muted = nextVolume === 0;
    video.volume = nextVolume;
    updateVolumeState();
  });

  video.addEventListener('play', updatePlayState);
  video.addEventListener('pause', updatePlayState);
  video.addEventListener('ended', updatePlayState);
  video.addEventListener('play', dismissOverlay);
  video.addEventListener('loadedmetadata', function () {
    updateTimeState();
    updateVolumeState();
  });
  video.addEventListener('timeupdate', updateTimeState);
  video.addEventListener('volumechange', updateVolumeState);

  updatePlayState();
  updateTimeState();
  updateVolumeState();
}

function initHomeLuxuryHeroCarousel(scope) {
  var context = scope || document;
  var carousels = [];

  if (context.matches && context.matches('[data-home-hero-carousel]')) {
    carousels.push(context);
  }
  context.querySelectorAll('[data-home-hero-carousel]').forEach(function (carousel) {
    carousels.push(carousel);
  });

  carousels.forEach(function (carousel) {
    if (carousel.dataset.heroCarouselInit === 'true') return;

    var slides = Array.from(carousel.querySelectorAll('[data-home-hero-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-home-hero-dot]'));
    var previous = carousel.querySelector('[data-home-hero-prev]');
    var next = carousel.querySelector('[data-home-hero-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileControls = window.matchMedia('(max-width: 749px)');
    var autoplay = carousel.dataset.autoplay === 'true';
    var interval = Math.max(Number(carousel.dataset.interval) || 7000, 5000);
    var activeIndex = Math.max(slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }), 0);
    var timer = null;
    var touchStartX = null;
    var suppressHeroLinkClick = false;
    var suppressHeroLinkTimer = null;
    var slideRequest = 0;
    var navigationIndex = activeIndex;
    var controlsHomeParent = previous ? previous.closest('.home-luxury__hero-controls').parentNode : null;
    var controlsHomeNextSibling = previous ? previous.closest('.home-luxury__hero-controls').nextSibling : null;
    var controls = previous ? previous.closest('.home-luxury__hero-controls') : null;

    function placeControls() {
      if (!controls) return;
      if (mobileControls.matches) {
        var activeCopy = slides[activeIndex] && slides[activeIndex].querySelector('.home-luxury__hero-copy');
        if (!activeCopy) return;
        var actions = activeCopy.querySelector('.home-luxury__hero-actions');
        if (actions) actions.insertAdjacentElement('afterend', controls);
        else activeCopy.appendChild(controls);
        controls.classList.add('is-inline-mobile');
        return;
      }
      controls.classList.remove('is-inline-mobile');
      if (controlsHomeParent && controls.parentNode !== controlsHomeParent) {
        var reference = controlsHomeNextSibling && controlsHomeNextSibling.parentNode === controlsHomeParent
          ? controlsHomeNextSibling
          : null;
        controlsHomeParent.insertBefore(controls, reference);
      }
    }

    function loadSlideImage(slide) {
      var image = slide.querySelector('img');
      if (!image) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        function cleanup() {
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
        }
        function failed() {
          cleanup();
          reject(new Error('Banner image could not load'));
        }
        function loaded() {
          if (!image.naturalWidth) return failed();
          cleanup();
          // Updating srcset/src can interrupt decode in some browsers. A
          // successfully loaded image is still usable after that rejection.
          if (image.decode) {
            image.decode().then(resolve).catch(function () {
              if (image.complete && image.naturalWidth) resolve();
              else reject(new Error('Banner image could not decode'));
            });
          } else resolve();
        }
        image.addEventListener('load', loaded);
        image.addEventListener('error', failed);
        image.loading = 'eager';
        if (image.dataset.src) {
          if (image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
            delete image.dataset.srcset;
          }
          image.src = image.dataset.src;
          delete image.dataset.src;
        }
        if (image.complete && image.naturalWidth) loaded();
      });
    }

    if (slides.length < 2) {
      carousel.dataset.heroCarouselInit = 'true';
      return;
    }

    function showSlide(index) {
      var requestedIndex = (index + slides.length) % slides.length;
      navigationIndex = requestedIndex;
      var request = ++slideRequest;
      var image = slides[requestedIndex].querySelector('img');
      if (image && (image.dataset.src || !image.complete || !image.naturalWidth)) {
        loadSlideImage(slides[requestedIndex]).then(function () {
          if (request === slideRequest) activateSlide(requestedIndex);
        }).catch(function () {
          // Keep the current, readable slide if an image request fails.
          if (request === slideRequest) navigationIndex = activeIndex;
        });
        return;
      }
      activateSlide(requestedIndex);
    }

    function activateSlide(index) {
      activeIndex = index;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      placeControls();
    }

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(function () {
        showSlide(activeIndex + 1);
      }, interval);
    }

    function showFromControl(index) {
      showSlide(index);
      startAutoplay();
    }

    if (previous) {
      previous.addEventListener('click', function () {
        showFromControl(navigationIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showFromControl(navigationIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showFromControl(Number(dot.dataset.homeHeroDot));
      });
    });

    carousel.addEventListener('pointerenter', stopAutoplay);
    carousel.addEventListener('pointerleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', function (event) {
      if (!carousel.contains(event.relatedTarget)) startAutoplay();
    });

    carousel.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0] ? event.touches[0].clientX : null;
      suppressHeroLinkClick = false;
      if (suppressHeroLinkTimer) window.clearTimeout(suppressHeroLinkTimer);
      stopAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches[0]) return;
      var distance = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) > 12) {
        suppressHeroLinkClick = true;
        suppressHeroLinkTimer = window.setTimeout(function () {
          suppressHeroLinkClick = false;
        }, 450);
      }
      if (Math.abs(distance) > 48) {
        showSlide(navigationIndex + (distance < 0 ? 1 : -1));
      }
      startAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchcancel', function () {
      touchStartX = null;
      suppressHeroLinkClick = false;
      startAutoplay();
    }, { passive: true });

    carousel.addEventListener('click', function (event) {
      if (!event.target.closest('[data-home-hero-hit-area]')) return;
      if (!suppressHeroLinkClick) return;
      event.preventDefault();
      event.stopPropagation();
    });

    carousel.addEventListener('shopify:block:select', function (event) {
      var selectedSlide = event.target.closest('[data-home-hero-slide]');
      if (!selectedSlide) return;
      stopAutoplay();
      showSlide(Number(selectedSlide.dataset.slideIndex));
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    reducedMotion.addEventListener('change', startAutoplay);
    mobileControls.addEventListener('change', placeControls);
    placeControls();
    showSlide(activeIndex);
    startAutoplay();
    carousel.dataset.heroCarouselInit = 'true';
  });
}

function initLazyVideos() {
  var videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function loadVideo(video) {
    if (!video || video.dataset.lazyLoaded === 'true') return;

    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (source) {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
    });

    video.dataset.lazyLoaded = 'true';
    video.load();

    if (video.autoplay && !reducedMotion.matches) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(loadVideo);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      loadVideo(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '500px 0px', threshold: 0.01 });

  videos.forEach(function (video) {
    observer.observe(video);
  });

  reducedMotion.addEventListener('change', function (event) {
    if (!event.matches) return;
    videos.forEach(function (video) { video.pause(); });
  });
}

function initEditorialVideos(root) {
  var shells = (root || document).querySelectorAll('[data-editorial-video-shell]:not([data-editorial-bound])');
  if (!shells.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target.querySelector('[data-editorial-video]');
      if (!video) return;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.2 && !reducedMotion.matches && !saveData && video.dataset.manualPause !== 'true') {
        load(video);
        attemptPlay(video);
      } else if (!entry.isIntersecting || entry.intersectionRatio < 0.2) {
        video.pause();
      }
    });
  }, { threshold: [0, 0.2] }) : null;

  function load(video) {
    if (!video.dataset.src) return;
    video.src = video.dataset.src;
    delete video.dataset.src;
    video.load();
  }

  function attemptPlay(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  shells.forEach(function (shell) {
    shell.dataset.editorialBound = 'true';
    var video = shell.querySelector('[data-editorial-video]');
    var play = shell.querySelector('[data-editorial-play]');
    var sound = shell.querySelector('[data-editorial-sound]');
    if (!video || !play || !sound) return;

    function sync() {
      var playing = !video.paused;
      var audible = !video.muted && video.volume > 0;
      play.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
      play.setAttribute('aria-pressed', playing ? 'true' : 'false');
      sound.setAttribute('aria-label', audible ? 'Mute film' : 'Unmute film');
      sound.setAttribute('aria-pressed', audible ? 'true' : 'false');
      play.querySelector('.editorial-video__icon--play').hidden = playing;
      play.querySelector('.editorial-video__icon--pause').hidden = !playing;
      sound.querySelector('.editorial-video__icon--muted').hidden = audible;
      sound.querySelector('.editorial-video__icon--sound').hidden = !audible;
    }

    play.addEventListener('click', function () {
      if (video.paused) {
        video.dataset.manualPause = 'false';
        load(video);
        attemptPlay(video);
      } else {
        video.dataset.manualPause = 'true';
        video.pause();
      }
    });
    sound.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) {
        video.dataset.manualPause = 'false';
        load(video);
        attemptPlay(video);
      }
      sync();
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('volumechange', sync);
    video.addEventListener('error', function () {
      play.disabled = true;
      sound.disabled = true;
    });
    sync();
    if (observer) observer.observe(shell);
  });

  reducedMotion.addEventListener('change', function (event) {
    if (event.matches) shells.forEach(function (shell) {
      var video = shell.querySelector('[data-editorial-video]');
      if (video) video.pause();
    });
  });
}

function initHomeLuxuryFilmAudio() {
  var section = document.querySelector('.home-luxury__film');
  if (!section) return;

  var frame = section.querySelector('.home-luxury__film-video-frame');
  var video = frame ? frame.querySelector('.home-luxury__film-video') : null;
  var toggle = frame ? frame.querySelector('[data-home-film-audio-toggle]') : null;
  var mutedIcon = toggle ? toggle.querySelector('.home-luxury__film-audio-icon--muted') : null;
  var liveIcon = toggle ? toggle.querySelector('.home-luxury__film-audio-icon--live') : null;

  if (!frame || !video || !toggle) return;

  function updateAudioState() {
    var isMuted = video.muted || video.volume === 0;
    toggle.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    toggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
    frame.classList.toggle('is-audio-live', !isMuted);
    if (mutedIcon) mutedIcon.hidden = !isMuted;
    if (liveIcon) liveIcon.hidden = isMuted;
  }

  toggle.addEventListener('click', function () {
    if (video.muted || video.volume === 0) {
      video.muted = false;
      if (video.volume === 0) {
        video.volume = 1;
      }
    } else {
      video.muted = true;
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }

    updateAudioState();
  });

  video.addEventListener('volumechange', updateAudioState);
  updateAudioState();
}

/* ═══════════════════════════════════════════════
   10. WAITLIST FORM
   ═══════════════════════════════════════════════ */

function initWaitlistForm() {
  var tierStep = document.getElementById('waitlist-step-tier');
  var formStep = document.getElementById('waitlist-step-form');
  var doneStep = document.getElementById('waitlist-step-done');
  if (!tierStep) return;

  var dots = document.querySelectorAll('.waitlist-dot');
  var tierCards = document.querySelectorAll('.tier-card');
  var form = document.getElementById('waitlist-form');
  var backBtn = document.getElementById('waitlist-back');
  var copyBtn = document.getElementById('copy-link-btn');
  var selectedTier = '';

  var tierNames = {
    'early-bird': 'Early Access',
    'vip-launch': 'RSVP LAUNCH',
    'inner-circle': 'Inner Circle'
  };

  function showStep(step) {
    tierStep.style.display = step === 'tier' ? 'block' : 'none';
    tierStep.classList.toggle('active', step === 'tier');
    formStep.style.display = step === 'form' ? 'block' : 'none';
    formStep.classList.toggle('active', step === 'form');
    doneStep.style.display = step === 'done' ? 'block' : 'none';
    doneStep.classList.toggle('active', step === 'done');

    dots.forEach(function (dot) {
      var s = dot.getAttribute('data-step');
      dot.classList.remove('active', 'completed');
      if (s === step) dot.classList.add('active');
      if (step === 'form' && s === 'tier') dot.classList.add('completed');
      if (step === 'done') dot.classList.add('completed');
    });
  }

  tierCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectedTier = card.getAttribute('data-tier');
      var borderColor = card.getAttribute('data-border-color');

      tierCards.forEach(function (c) {
        c.classList.remove('selected');
        c.style.borderColor = 'rgba(255,255,255,0.1)';
      });
      card.classList.add('selected');
      card.style.borderColor = borderColor;

      setTimeout(function () { showStep('form'); }, 400);
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () { showStep('tier'); });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameInput = form.querySelector('input[name="name"]');
      var name = nameInput ? nameInput.value : 'friend';

      var doneName = document.getElementById('waitlist-done-name');
      if (doneName) doneName.textContent = "You're on the list, " + (name || 'friend') + '.';

      var doneTier = document.querySelector('#waitlist-done-tier span');
      if (doneTier) doneTier.textContent = tierNames[selectedTier] || selectedTier;

      showStep('done');
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy Link'; }, 2000);
      }
    });
  }
}

/* ═══════════════════════════════════════════════
   11. CONTACT FORM
   ═══════════════════════════════════════════════ */

function initContactForm() {
  var form = document.getElementById('contact-form');
  if (!form) return;

  var formWrap = document.getElementById('contact-form-wrap');
  var thankYou = document.getElementById('contact-thank-you');
  var errorEl = document.getElementById('contact-form-error');
  var submitBtn = form.querySelector('button[type="submit"]');
  var stateEl = form.querySelector('[data-contact-form-state]');
  var postedSuccessfully = stateEl && stateEl.getAttribute('data-posted-successfully') === 'true';
  var hasErrors = stateEl && stateEl.getAttribute('data-has-errors') === 'true';
  var shouldRestoreView = postedSuccessfully || hasErrors;

  function scrollToContactState(target) {
    if (!target) return;

    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }, 140);
    });
  }

  if (postedSuccessfully) {
    if (formWrap) formWrap.style.display = 'none';
    if (thankYou) thankYou.style.display = 'block';
  } else if (hasErrors) {
    if (formWrap) formWrap.style.display = 'block';
    if (thankYou) thankYou.style.display = 'none';
  }

  if (shouldRestoreView) {
    cleanContactPostedUrl();
    scrollToContactState(postedSuccessfully ? thankYou : formWrap);
  }

  // Focus/blur styling
  form.querySelectorAll('input, textarea').forEach(function (input) {
    input.addEventListener('focus', function () {
      input.style.borderBottomColor = 'var(--vibrant-orange)';
    });
    input.addEventListener('blur', function () {
      input.style.borderBottomColor = 'var(--orchid-mist)';
    });
  });

  form.addEventListener('submit', function (e) {
    var messageField = form.querySelector('textarea[name="contact[body]"]');
    var phoneField = form.querySelector('input[name="contact[phone]"]');
    var message = messageField ? messageField.value : '';
    var phoneValue = getPhoneNumberValue(phoneField);

    if (phoneField && phoneValue) {
      phoneField.value = phoneValue;
    }
    if (messageField && phoneValue && message.indexOf('\n\nPhone: ') === -1) {
      messageField.value = message + '\n\nPhone: ' + phoneValue;
    }

    if (errorEl) {
      errorEl.style.display = 'none';
      errorEl.textContent = '';
    }
    if (submitBtn) submitBtn.disabled = true;
  });
}

function initWyshPage() {
  if (!window.location || window.location.pathname.indexOf('/a/wysh') !== 0) return;

  document.body.classList.add('is-wysh-page');

  var wishlistHeading = Array.prototype.find.call(document.querySelectorAll('h1'), function (heading) {
    return (heading.textContent || '').trim().toLowerCase() === 'wishlist';
  });

  if (!wishlistHeading) return;

  function includesText(element, text) {
    return element && (element.textContent || '').indexOf(text) !== -1;
  }

  function findClosestAncestor(node, matcher) {
    var current = node;
    while (current && current !== document.body) {
      if (matcher(current)) return current;
      current = current.parentElement;
    }
    return null;
  }

  var pageRoot = findClosestAncestor(wishlistHeading, function (element) {
    return !!element.querySelector('button') &&
      includesText(element, 'Create New List') &&
      (
        includesText(element, 'available for 30 days') ||
        !!Array.prototype.find.call(element.querySelectorAll('h2'), function (heading) {
          return (heading.textContent || '').toLowerCase().indexOf('wishlist') !== -1;
        }) ||
        !!element.querySelector('a[href*="/products/"]')
      );
  }) || wishlistHeading.parentElement;

  if (!pageRoot) return;

  pageRoot.setAttribute('data-wysh-page-root', '');

  var headerRow = Array.prototype.find.call(pageRoot.querySelectorAll('div'), function (element) {
    return element.querySelector('h1') && includesText(element, 'Create New List');
  });
  if (headerRow) headerRow.classList.add('wysh-page__hero');

  wishlistHeading.classList.add('wysh-page__title');

  var createButton = Array.prototype.find.call(pageRoot.querySelectorAll('button'), function (button) {
    return includesText(button, 'Create New List');
  });
  if (createButton) createButton.classList.add('wysh-page__create');

  var noticeRow = Array.prototype.find.call(pageRoot.querySelectorAll('div, p'), function (element) {
    return includesText(element, 'available for 30 days');
  });
  if (noticeRow) noticeRow.classList.add('wysh-page__notice');

  var emptyHeading = Array.prototype.find.call(pageRoot.querySelectorAll('h2'), function (heading) {
    return (heading.textContent || '').trim().toLowerCase() === 'your wishlist is empty';
  });

  var emptyBlock = emptyHeading ? findClosestAncestor(emptyHeading, function (element) {
    return !!Array.prototype.find.call(element.querySelectorAll('button'), function (button) {
      return includesText(button, 'Continue Shopping');
    });
  }) : null;

  if (emptyBlock) {
    emptyBlock.classList.add('wysh-page__empty');
    emptyHeading.classList.add('wysh-page__empty-title');
  }

  var continueButton = Array.prototype.find.call(pageRoot.querySelectorAll('button'), function (button) {
    return includesText(button, 'Continue Shopping');
  });
  if (continueButton) continueButton.classList.add('wysh-page__cta');

  pageRoot.querySelectorAll('a[href="/account/login"]').forEach(function (link) {
    link.classList.add('wysh-page__link');
  });

  var itemCountLabel = Array.prototype.find.call(pageRoot.querySelectorAll('div, p, span'), function (element) {
    var text = (element.textContent || '').trim().toLowerCase();
    return /(^|\s)\d+\s+item/.test(text);
  });
  if (itemCountLabel) itemCountLabel.classList.add('wysh-page__count');

  var productLinks = Array.prototype.slice.call(pageRoot.querySelectorAll('a[href*="/products/"]'));
  var productItems = [];

  productLinks.forEach(function (link) {
    var item = findClosestAncestor(link, function (element) {
      return !!element.querySelector('select') &&
        !!Array.prototype.find.call(element.querySelectorAll('button'), function (button) {
          return includesText(button, 'Add to cart') || includesText(button, 'Sold out') || includesText(button, 'Unavailable');
        });
    });

    if (!item || productItems.indexOf(item) !== -1) return;
    productItems.push(item);
  });

  if (productItems.length) {
    var listRoot = findClosestAncestor(productItems[0], function (element) {
      return element.tagName === 'UL' || element.tagName === 'OL';
    });

    if (listRoot) listRoot.classList.add('wysh-page__list');

    productItems.forEach(function (item) {
      item.classList.add('wysh-page__item');

      var imageLink = Array.prototype.find.call(item.querySelectorAll('a[href*="/products/"]'), function (link) {
        return !!link.querySelector('img');
      });
      if (imageLink) imageLink.classList.add('wysh-page__item-media');

      var titleLink = Array.prototype.find.call(item.querySelectorAll('a[href*="/products/"]'), function (link) {
        return !link.querySelector('img');
      });
      if (titleLink) titleLink.classList.add('wysh-page__item-title');

      var select = item.querySelector('select');
      if (select) select.classList.add('wysh-page__item-select');

      var actionButton = Array.prototype.find.call(item.querySelectorAll('button'), function (button) {
        return includesText(button, 'Add to cart') || includesText(button, 'Sold out') || includesText(button, 'Unavailable');
      });
      if (actionButton) actionButton.classList.add('wysh-page__item-add');
    });
  }

  pageRoot.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
    link.classList.add('wysh-page__product-link');
  });

  pageRoot.querySelectorAll('img').forEach(function (image) {
    image.classList.add('wysh-page__image');
  });
}
